import { normalizedTranslate, toPx } from '@rbilabs/components-library';
import styled, { css } from 'styled-components';

import { ButtonForIconFav } from 'components/favorite-icon/styled';

import CarouselIcon from './carousel-icon';

export const CAROUSEL_CARD_WIDTH = 370;
export const CAROUSEL_CARD_MARGIN = 20;

export const CarouselContainer = styled.div`
  width: 100%;

  ${Styles.desktop} {
    max-width: 1136px;
    margin: 0 auto;
  }
`;

export const CarouselHeader = styled.div`
  display: flex;
  width: 100%;
  padding-block-start: 1rem;
  padding-block-end: 0;
  padding-inline: 1rem;
`;

export const CarouselLink = styled.a`
  margin-inline-start: auto;
  font-size: 0.85rem;
  text-decoration: underline;
  line-height: 1.6rem;
  cursor: pointer;
`;

export const CarouselTitle = styled.div`
  font-family: 'Flame';
  font-style: normal;
  font-weight: 500;
  font-size: 1.125rem;
`;

export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CarouselScrollableWrapper = styled.div`
  overflow: auto;
  max-width: 100vw;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  ${Styles.desktop} {
    position: relative;
    overflow: hidden;
    max-width: unset;
  }
`;

export const CarouselCardContainer = styled.div<{ shouldScroll: boolean; offset?: number }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: ${p => (p.shouldScroll ? '16rem' : 'unset')};
  width: max-content;
  padding: 1.25rem 1rem;

  ${Styles.desktop} {
    flex-direction: ${(p: any) => (p.shouldScroll ? 'column' : 'row')};
    transition: 0.5s ease-in-out;
    ${(p: any) =>
      p.offset &&
      css`
        transform: ${normalizedTranslate(
          toPx(-p.offset * (CAROUSEL_CARD_WIDTH + CAROUSEL_CARD_MARGIN))
        )};
      `}
  }
`;

export const CarouselItem = styled.div<{ fullWidth?: boolean }>`
  width: ${p => (p.fullWidth ? '90vw' : '75vw')};
  padding: 0.75rem 1rem;
  border-block-end: 1px solid ${Styles.shadowColor};
  margin-inline-end: ${p => (p.fullWidth ? '0' : '0.5rem')};
  flex: 1 1 6.5rem;
  max-height: 6.5rem;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  position: relative;

  &:nth-of-type(even) {
    border-block-end: none;
  }

  &:only-child {
    border-block-end: none;
  }

  ${Styles.desktop} {
    min-width: calc(${CAROUSEL_CARD_WIDTH}px - 1rem);
    max-width: ${CAROUSEL_CARD_WIDTH}px;
    margin-inline-end: 0.5rem;
    border-block-end: none;

    &:nth-child(n + 4) {
      border-block-start: 1px solid ${Styles.shadowColor};
    }
  }
`;

export const PictureWrapper = styled.div`
  position: relative;
  width: 6.25rem;
  max-height: 5rem;
  border-radius: 0.5rem;
`;

export const OfferDetails = styled.div`
  width: calc(100% - 6.25rem);
  padding-block-start: 0.125rem;
  padding-inline-start: 0.75rem;
`;

export const OfferTitle = styled.div`
  font-family: 'Flame';
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  height: 2rem;
  padding-inline-end: 1.2rem;
  line-height: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const OfferDescription = styled.div`
  font-size: 0.75rem;
  height: 2rem;
  margin-block-start: 0.2rem;
  line-height: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const CarouselNextButton = styled(CarouselIcon)`
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  margin: auto 0;
  z-index: 10;
  cursor: pointer;
`;

export const CarouselPrevButton = styled(CarouselNextButton)`
  transform: rotateY(190deg);
  inset-inline-end: unset;
`;

export const LoadingWrapper = styled.div`
  height: 2.125rem;
`;

export const FavoriteIconButton = styled(ButtonForIconFav)`
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
`;
